<template>
    <div class="container-fluid mt-2">
        <div class="row">
            <div class="card">
                <div class="card-header">Limit arttırma
                    <a href="javascript:void(0);">( Export to excel )</a>
                </div>
                <div class="card-block p-0">
                    <div class="table-responsive">
                        <div class="bootstrap-table">
                            <div class="fixed-table-toolbar"></div>
                            <div class="fixed-table-container" style="padding-bottom: 0px;">
                                <div class="fixed-table-header" style="display: none;">
                                    <table></table>
                                </div>
                                <div class="fixed-table-body">
                                    <table id="table" data-toggle="table" class="table table-hover">
                                        <thead v-if="$root.windowWidth >= 600">
                                        <tr>
                                            <th style="" data-field="id" tabindex="0">
                                                <div class="th-inner ">id</div>
                                                <div class="fht-cell"></div>
                                            </th>
                                            <th style="" data-field="BayiAD" tabindex="0">
                                                <div class="th-inner ">{{ t.user.groups.ROLE_RESELLER }}</div>
                                                <div class="fht-cell"></div>
                                            </th>
                                            <th style="" data-field="Tutar" tabindex="0">
                                                <div class="th-inner ">Tutar</div>
                                                <div class="fht-cell"></div>
                                            </th>
                                            <th style="" data-field="Tarih" tabindex="0">
                                                <div class="th-inner ">{{ t.betting.title.date }}</div>
                                                <div class="fht-cell"></div>
                                            </th>
                                            <th style="" data-field="Islem" tabindex="0">
                                                <div class="th-inner ">Islem</div>
                                                <div class="fht-cell"></div>
                                            </th>
                                            <th>
                                                <div class="th-inner ">Durum</div>

                                            </th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr class="no-records-found" v-if="loading">
                                            <td colspan="5" align="center">
                                                <Loading></Loading>
                                            </td>
                                        </tr>
                                        <template v-if="!loading">
                                            <tr class="no-records-found" v-if="transactions.length < 1">
                                                <td colspan="5">Kayıt bulunamadı</td>
                                            </tr>
                                            <template v-else-if="$root.windowWidth < 600">
                                                <tr v-for="(transaction, idx) in transactions" :key="idx">
                                                    <td colspan="5">
                                                        <div class="card-views">
                                                            <div class="card-view">
                                                                <span class="title">id</span>
                                                                <span class="value">{{ transaction.id }}</span></div>
                                                            <div class="card-view">
                                                                <span class="title">{{ t.user.groups.ROLE_RESELLER }}</span>
                                                                <span>{{ transaction.user.username }}</span>
                                                            </div>
                                                            <div class="card-view">
                                                                <span class="title">Tutar</span> <!-- tr -->
                                                                <span class="value amnount" :class="transaction.type.operator === '+' ? 'text-success' : 'text-danger'">{{ transaction.amount }}</span>
                                                            </div>
                                                            <div class="card-view">
                                                                <span class="title">{{ t.betting.title.date }}</span>
                                                                <span class="value">{{ dateTimeFormat(transaction.addedAt) }}</span>
                                                            </div>
                                                            <div class="card-view">
                                                                <span class="title">Islem</span> <!-- tr -->
                                                                <span class="value">{{ transaction.info }}</span>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        {{ transaction.status }}
                                                        <a v-show="transaction.status === 'Pending' && transaction.user.id !== session.uid" class="mr-2 mb-2 btn btn-outline-success" v-on:click="setTransaction(1, transaction)"> {{ t.approve }}</a>
                                                        <a v-show="transaction.status === 'Pending' && transaction.user.id !== session.uid" class="mr-2 mb-2 btn btn-outline-danger" v-on:click="setTransaction(0, transaction)"> {{ t.cancel }}</a>
                                                    </td>
                                                </tr>
                                            </template>
                                            <template v-else>
                                                <tr v-for="(transaction, idx) in transactions" :key="idx">
                                                    <td>{{ transaction.id }}</td>
                                                    <td>
                                                        <span>{{ transaction.user.username }}</span>
                                                    </td>
                                                    <td>
                          <span class="amount">
                            <code :class="transaction.type.operator === '+' ? 'text-success' : 'text-danger'">{{ transaction.amount | toMoney(session.currency) }}</code>
                          </span>
                                                    </td>
                                                    <td>{{ dateTimeFormat(transaction.addedAt) }}</td>
                                                    <td>{{ transaction.info }}</td>
                                                    <td>
                                                        {{ transaction.status }}
                                                        <a v-show="transaction.status === 'Pending' && transaction.user.id !== session.uid" class=" btn btn-outline-success" v-on:click="setTransaction(1, transaction)"> {{ t.approve }}</a>
                                                        <a v-show="transaction.status === 'Pending' && transaction.user.id !== session.uid" class=" btn btn-outline-danger" v-on:click="setTransaction(0, transaction)"> {{ t.cancel }}</a>
                                                    </td>
                                                </tr>
                                            </template>
                                        </template>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="fixed-table-footer">
                                    <paginate v-if="pagination" class="mx-3"
                                              :page-count="pagination.pageCount"
                                              :page-range="pagination.pageRange"
                                              :force-page="(pagination.current)"
                                              :initialPage="(pagination.current)"
                                              :margin-pages="$root.windowWidth < 600 ? 0 : 2"
                                              :click-handler="onChangePage"
                                              :prev-text="t.previous"
                                              :next-text="t.next"
                                              :container-class="'my-1 pagination float-right mr-0 ml-1'"
                                              :page-class="'page-item'"
                                              :page-link-class="'page-link'"
                                              :prev-class="'page-item'"
                                              :prev-link-class="'page-link'"
                                              :next-class="'page-item'"
                                              :next-link-class="'page-link'"
                                    >
                                    </paginate>
                                </div>
                            </div>
                        </div>
                        <div class="clearfix"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Paginate from 'vuejs-paginate'
    import Loading from "../Loading";
    export default {
        name: "LimitLog",
        components: {Loading, Paginate },
        data() {
            return {
                transactions: [],
                session: session,
                pagination: null,
                t: this.$root.t,
                loading: false
            }
        },
        mounted() {
            this.$router.push({ query: {page: 1} });
            this.fetchTransactions();
        },
        methods: {
            setTransaction(answer, transaction) {
                this.$http.get(api+'api/v1/user/transaction/request/approve', { params: {answer: answer, id: transaction.id} }).then(
                    response => {
                        // get body data
                        this.isLoading = false;
                        this.status = response.status;

                        this.$fire({
                            title: this.t.processing.success,
                            text: this.t.processing.check,
                            type: "success",
                            timer: 3000
                        }).then(r => {

                        });

                    }, response => {
                        this.isLoading = false;
                        this.status = response.status;

                        this.$fire({
                            title:this.t.processing.error,
                            text: response.body.msg,
                            type: "error",
                            timer: 3000
                        }).then(r => {

                        });

                    })
            },
            fetchTransactions() {
                this.loading = true;
                this.$http.get(api + 'api/v1/user/transactions', {
                    params: {
                        type: [46],
                        page: this.$route.query.page,
                        per_page: 10,
                        direction: 'desc',
                        noCache: 1,
                        onlyReseller: 1
                    }
                })
                    .then(response => {
                        this.transactions = response.body.result.transactions;
                        this.pagination = response.body.result.pagination;
                        this.loading = false;
                        this.notfound = false;
                    }, response => {
                        this.transactions = [];
                        this.loading = false;
                        this.notfound = true;
                    })
            },
            onChangePage (page) {
                this.pagination.current = page;
                this.$router.push({ query: {page: page} });
                window.scroll(0, 0);
                this.fetchTransactions()
            },
        }
    }
</script>

<style scoped>
    .something {
        width: 100px;
    }

    .pagination {
        margin-right: 20px;
    }

    .pagination-detail {
        margin-left: 20px;
    }

    .fixed-table-pagination .dropup .dropdown-menu li:hover {
        background-color: #20a8d8;
        color: #fff !important;
    }

    .fixed-table-pagination .dropup .dropdown-menu li a {
        width: 100%;
        display: inline-block;
        padding: 10px;
    }

    .fixed-table-pagination .dropup .dropdown-menu li a:hover {
        color: #fff;
    }

    .btn:first-child {
        border: 1px solid #ccc;
        margin: 0 20px !important;
    }
    @media only screen and (min-width: 0px) and (max-width: 800px) {
        .export {
            display: none !important;
        }
    }

</style>


// WEBPACK FOOTER //
// src/components/views/LimitRequests.vue